module.exports = __webpack_public_path__ + "static/media/กุน.de750f17.jpg";